<template>
  <div v-redirect-if-no-permission:DRIVERS>
    <loading-component :value="loading" />

    <DataTable descending :url="api.ACTIONS.CAPTAIN_PAYMENTS($route.params.id)" :enable-edit="false" :enable-add="false"
      :enable-delete="false" :formatter="formatters" perPage="25" :fields-hidden-main="[]" :titles="titles"
      :title='$t("captainProfilePage.payments.title")' />


  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

export default {
  name: "CaptainPayments",
  title: "captainProfilePage.profile.pageTitle",
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      switch1: null,

      loading: false,

    };
  },

  computed: {
    formatters() {
      const self = this;
      return {
        created_at(value) {
          // Final-version doc 2026-10-05: company clock (UTC+3).
          return formatCompanyTime(value, "YYYY-MM-DD HH:mm");
        },
        entity_type(value) {
          if (value) {
            let tmp = value.split("\\");
            return tmp[tmp.length - 1];
          } else return value;

        },
        user_type(value) {
          if (value) {
            let tmp = value.split("\\");
            let tmp1=tmp[tmp.length - 1];
            return tmp1 == "Captain" ? self.$t("captainProfilePage.payments.driver") : tmp1;
          } else return value;

        },
        meter_price(value) {
          return self.formatMoney(value);
        },
        captain_amount(value) {
          return self.formatMoney(value);
        },
        required_to_pay(value) {
          return self.formatMoney(value);
        },
        owner_cut(value) {
          return self.formatMoney(value);
        },
        discount_amount(value) {
          return self.formatMoney(value);
        },
        company_amount(value) {
          return self.formatMoney(value);
        },
        remaining_amount(value) {
          return self.formatMoney(value);
        },
        // QA-3 #1: the REAL configured rates persisted at settlement. Legacy
        // rows (pre C2-breakdown) have no value — show a dash, never a guess.
        company_percentage(value) {
          return value == null ? "—" : `${Number(value)}%`;
        },
        driver_percentage(value) {
          return value == null ? "—" : `${Number(value)}%`;
        },
        owner_percentage(value) {
          return value == null ? "—" : `${Number(value)}%`;
        },
        captain_percentage(value) {
          return value == null ? "—" : `${Number(value)}%`;
        },
        // QA-3 #2: business-billed rides name the paying establishment.
        business_payer_name(value) {
          return value ? self.$t("captainProfilePage.payments.businessPayer", { name: value }) : "—";
        },
        // Owner item 2.1: the row of a ride whose company commission the
        // restricted welcome balance covered. Every other type keeps its raw
        // value, escaped as DataTable does when no formatter is given.
        payment_type(value) {
          if (value === "WELCOME_BONUS") {
            return self.$t("captainProfilePage.payments.paymentTypeWelcomeBonus");
          }
          // Accountant doc 2026-10-03 item 1.5.
          if (value === "CANCELLATION_COMPENSATION") {
            return self.$t("captainProfilePage.payments.paymentTypeCancellationCompensation");
          }
          return value === null || value === undefined
            ? ""
            : String(value)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        },
      };
    },
    titles() {
      return {
        id: "#",
        meter_price: this.$t("captainProfilePage.payments.meterPrice"),
        // QA-3 #1: captain_percentage is the driver's TOTAL share of the fare
        // (derived), not the configured commission — label it accordingly and
        // show the real configured splits alongside.
        captain_percentage: this.$t("captainProfilePage.payments.driverShareOfTotal"),
        company_percentage: this.$t("captainProfilePage.payments.companyPercent"),
        driver_percentage: this.$t("captainProfilePage.payments.driverPercent"),
        owner_percentage: this.$t("captainProfilePage.payments.ownerPercent"),
        company_amount: this.$t("captainProfilePage.payments.companyAmount"),
        remaining_amount: this.$t("captainProfilePage.payments.afterCommission"),
        captain_amount: this.$t("captainProfilePage.payments.driverAmount"),
        required_to_pay: this.$t("captainProfilePage.payments.driverCommission"),
        owner_cut: this.$t("captainProfilePage.payments.ownerCut"),
        voucher: this.$t("captainProfilePage.payments.voucher"),
        discount_amount: this.$t("captainProfilePage.payments.discountAmount"),
        payment_type: this.$t("captainProfilePage.payments.paymentType"),
        business_payer_name: this.$t("captainProfilePage.payments.paymentSource"),
        created_at: this.$t("captainProfilePage.payments.paymentDate"),
        entity_type: this.$t("captainProfilePage.payments.entityType"),
        entity_id: this.$t("captainProfilePage.payments.entityId"),
        user_full_name: this.$t("captainProfilePage.payments.user"),
        user_type: this.$t("captainProfilePage.payments.userType"),
        //user_username: "User Email"
      };
    },

  },

  methods: {

  },
};
</script>

<style scoped></style>
